<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class=" fas fa-microphone-alt text-primary"></i> Announcement</h5>
      </div>
      <hr>
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Title<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Title">
        </div>
        <div class="col-md-3">
          <label class="form-label">Type<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Type">
        </div>
        <div class="col-md-3">
          <label class="form-label">From Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input class="form-control form-control-sm" type="date" v-model="Obj.FromDate" />
        </div>
        <div class="col-md-3">
          <label class="form-label">To Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input class="form-control form-control-sm" type="date" v-model="Obj.ToDate" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Details :</label>
          <textarea class="form-control form-control-sm rounded" aria-label="With textarea" v-model="Obj.Details"></textarea>
        </div>
        <div class="col-md-9 mt-5  text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i
              class="fa fa-save" ></i> Save</button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row">
        <div class="col-sm-12 table-responsive mt-3">
           <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Title" @delRecord="delRecord" @closeModal="delObj.Title = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { formatDate, curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( { Title: "", Type: "", FromDate: new Date().toISOString().slice(0, 10), ToDate: new Date().toISOString().slice(0, 10), Details: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Title', key: 'Title' },
  { label: 'Type', key: 'Type' },
  { label: 'From Date', key: 'Datefrom'},
  { label: 'To Date', key: 'Dateto' },
  { label: 'Details', key: 'Details', truncatable: true }
]);
const handleEdit = (row) => {
    Obj.value = { ...row,
      FromDate: row.FromDate ? row.FromDate.slice(0, 10) : new Date().toISOString().slice(0, 10),
      ToDate: row.ToDate ? row.ToDate.slice(0, 10) : new Date().toISOString().slice(0, 10),
     }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
 const  save =async() =>  {
      const fields = {
        Title: { value: Obj.value.Title, validators: [isRequired], },
        Type: { value: Obj.value.Type, validators: [isRequired], },
        FromDate: { value: Obj.value.FromDate, validators: [isRequired], },
        ToDate: { value: Obj.value.ToDate, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/Announcement${url}`, Obj.value)
          .then(() => {
            loadData();
            reset();
            msgObj.value = { msg: `Announcement ${msg} Successfuly`, role: "success", show: true };
          }).catch(err => console.error(err));
      }
    }
    const reset =async () => {
      Obj.value = { Title: "", Type: "", FromDate: new Date().toISOString().slice(0, 10), ToDate: new Date().toISOString().slice(0, 10), Details: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
     const progress = ref(0)
    const loadData =async () =>{
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/Announcement/all').then((response) => { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1,
        Datefrom: formatDate(item.FromDate),Dateto: formatDate(item.ToDate), }));
        progress.value = 0
        clearInterval(progressInterval)
      });
    }
    const delRecord =async () =>{
      await api.delete(`/Announcement/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Announcement Deleted Successfuly.", role: "danger", show: true, };
        })
        .catch(err => console.error(err));
    }
    onMounted(() => { loadData() })
</script>
